/*
 * This file is part of glowingblue/datavis.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Tabs from './Tabs';
import TabItem from './TabItem';

export default class DataVisPage extends Page {
	oninit(vnode) {
		super.oninit(vnode);

		app.history.push('analytics');
		this.bodyClass = 'App--analytics';
		app.setTitle('Analytics');

		this.refresh();
	}

	view() {
		if (this.loading) {
			return <LoadingIndicator />;
		}

		if (!this.dataVis) {
			return null;
		}

		return (
			<div className='DataVisPage'>
				<div className='DataVisPage-content'>
					<Tabs _children={this.dataVis} ChildComponent={TabItem} />
				</div>
			</div>
		);
	}

	refresh() {
		this.loading = true;
		m.redraw();

		app.store.find('glowingblue_datavis').then((dataVis) => {
			this.dataVis = dataVis;
			this.loading = false;
			m.redraw();
		});
	}
}
